export * from './slider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/slider/index.js
// module id = 718
// module chunks = 3